export default "dist/images/block-notification-bordered.934d89b.png";